export const events = [
  {
    id: "starlight-backstage-voice",
    title: "星河音乐节后台对话外流",
    category: "音乐现场",
    categorySlug: "music",
    summary:
      "一段后台走廊的对话片段在多个平台流出，官方先后给出两种口径。这里把原始片段、现场录屏与官方物料按时间排好，方便对照前后说法。",
    cover: "https://readdy.ai/api/search-image?query=moody%20concert%20backstage%20corridor%20with%20warm%20amber%20lighting%20and%20blurred%20silhouettes%2C%20dark%20editorial%20investigative%20photography%2C%20dramatic%20atmosphere%2C%20fine%20film%20grain%2C%20no%20text&width=1200&height=800&seq=chigua-cover-01&orientation=landscape",
    coverAlt: "星河音乐节后台走廊暖色灯光下的现场氛围图",
    updatedAt: "2026-09-11",
    evidenceCount: 42,
    status: "持续更新",
    heat: 96,
    tags: ["后台对话", "两种口径", "现场录屏"],
    timeline: [
      { date: "2026-08-28", title: "片段首次出现", text: "某短视频账号发布 47 秒后台走廊片段，标注为「内部流出」，未提供原始录制者信息。" },
      { date: "2026-08-29", title: "官方第一版回应", text: "工作室声明称该片段为「恶意剪辑的拼接音频」，但未公布完整原文件。" },
      { date: "2026-09-03", title: "现场录屏被翻出", text: "观众上传同机位完整录屏，显示片段所处时间段与官方声明的时间点存在约 8 分钟偏差。" },
      { date: "2026-09-07", title: "官方第二版说明", text: "工作室改口表示「片段真实存在，但上下文被省略」，与第一版声明的表述不一致。" },
      { date: "2026-09-11", title: "音轨比对整理完成", text: "第三方音频博主完成两段音轨的频谱比对，结论已归档至证据清单第 12 条。" },
    ],
    evidences: [
      { type: "录音证据", title: "后台走廊 47 秒原始片段", desc: "含环境底噪与第三人声，未做降噪处理，可听到完整对话起止。", source: "短视频平台 @现场记录者", verified: true },
      { type: "视频素材", title: "同机位完整录屏（12 分 03 秒）", desc: "观众席视角，含现场 LED 屏计时信息，可用于锚定真实时间点。", source: "观众自主上传", verified: true },
      { type: "截图证据", title: "官方第一版声明原文截图", desc: "发布于 08-29 20:14，截图保留浏览器时间与页面结构。", source: "工作室官方账号", verified: true },
      { type: "文字记录", title: "第一版与第二版声明差异逐字稿", desc: "把两份声明并列，标出 4 处措辞改动与 2 处结论性表述变化。", source: "本站整理", verified: true },
      { type: "截图证据", title: "流传账号的发布时间线", desc: "记录同一账号在 3 天内的 6 次转发与 2 次删稿行为。", source: "平台公开主页", verified: false },
    ],
  },
  {
    id: "sweet-bakery-endorsement",
    title: "甜心面包店代言口径反复",
    category: "品牌代言",
    categorySlug: "brand",
    summary:
      "品牌在两天内对是否续约给出完全相反的说法，物料下架时间与声明发布时间也被网友整理出来。截图证据集中在这里，方便直接对照。",
    cover: "https://readdy.ai/api/search-image?query=warm%20bakery%20counter%20with%20soft%20amber%20light%20and%20empty%20display%20case%2C%20dark%20moody%20editorial%20still%20life%2C%20muted%20crimson%20accents%2C%20cinematic%20shadows%2C%20no%20text&width=1200&height=800&seq=chigua-cover-02&orientation=landscape",
    coverAlt: "暖光面包店柜台与空展示柜的暗调氛围图",
    updatedAt: "2026-09-09",
    evidenceCount: 28,
    status: "已归档",
    heat: 78,
    tags: ["代言续约", "物料下架", "声明矛盾"],
    timeline: [
      { date: "2026-08-30", title: "海报集中下架", text: "多城线下门店海报在当日上午集中撤换，网友拍下同位置前后对比图。" },
      { date: "2026-08-31", title: "品牌称「正常轮换」", text: "客服口径为「常规物料轮换，与代言人合作一切正常」。" },
      { date: "2026-09-01", title: "第二条声明反转", text: "品牌官方账号发文称合作已于 8 月到期，与前一天客服口径相互矛盾。" },
      { date: "2026-09-05", title: "下架时间线整理完成", text: "网友汇总 11 家门店的换装时间，最早的换装发生在 8 月 29 日下午。" },
      { date: "2026-09-09", title: "事件归档", text: "双方均未再补充说明，本站把截图证据按门店编号归档。" },
    ],
    evidences: [
      { type: "截图证据", title: "门店海报前后对比图（11 组）", desc: "同一位置、同一角度拍摄，含拍摄时间水印，可判断换装先后顺序。", source: "网友投稿汇总", verified: true },
      { type: "截图证据", title: "客服对话记录", desc: "包含 08-31 与 09-01 两次咨询，客服回复内容前后不一致。", source: "消费者提供", verified: true },
      { type: "文字记录", title: "两条官方声明的发布时间对照", desc: "8 月 31 日客服口径与 9 月 1 日官方发文并列展示。", source: "本站整理", verified: true },
      { type: "截图证据", title: "电商页面详情改动记录", desc: "商品详情页代言模块在 8 月 30 日凌晨被移除。", source: "平台快照", verified: false },
    ],
  },
  {
    id: "midnight-radio-leak",
    title: "深夜电台录音外流",
    category: "网络争议",
    categorySlug: "dispute",
    summary:
      "一段自称「完整版」的电台录音在论坛流传，但时长与官方回放相差近 4 分钟。这里保留了两版音频、波形图与原始回放入口。",
    cover: "https://readdy.ai/api/search-image?query=dim%20radio%20studio%20with%20glowing%20console%20lights%20and%20warm%20amber%20glow%2C%20empty%20microphone%20in%20shadow%2C%20dark%20photographic%20mood%2C%20cinematic%20grain%2C%20no%20text&width=1200&height=800&seq=chigua-cover-03&orientation=landscape",
    coverAlt: "暗光电台直播间调音台与话筒的氛围图",
    updatedAt: "2026-09-08",
    evidenceCount: 19,
    status: "整理中",
    heat: 64,
    tags: ["完整版质疑", "波形比对", "时长差异"],
    timeline: [
      { date: "2026-08-22", title: "录音初现论坛", text: "某论坛出现标注为「深夜电台完整录音」的音频文件，时长 51 分 20 秒。" },
      { date: "2026-08-23", title: "官方回放被找到", text: "听众找到当期节目官方回放，时长 55 分 04 秒，与流传版本存在明显差口。" },
      { date: "2026-08-26", title: "波形比对发布", text: "技术向博主公开两段音频波形图，指出流传版本在中段有一处 3 分 40 秒的空档。" },
      { date: "2026-09-08", title: "补充回放入口", text: "把官方回放的原始链接与访问时间一并归档，方便自行核对。" },
    ],
    evidences: [
      { type: "录音证据", title: "流传版录音（51 分 20 秒）", desc: "论坛原帖附件，保留文件哈希值用于比对，未做二次压缩。", source: "论坛原帖", verified: false },
      { type: "录音证据", title: "官方回放音频（55 分 04 秒）", desc: "来源为节目官方回放入口，保留访问时间与页面截图。", source: "节目官方回放", verified: true },
      { type: "截图证据", title: "两段音频波形对照图", desc: "横轴对齐后可见流传版本中段存在空档，官方版本无此空档。", source: "技术博主", verified: true },
      { type: "文字记录", title: "时长差异说明", desc: "把两版音频的起止点、空档位置与可能成因逐条列出。", source: "本站整理", verified: true },
    ],
  },
  {
    id: "live-room-gift-split",
    title: "直播间打赏分成风波",
    category: "直播风波",
    categorySlug: "livestream",
    summary:
      "主播与运营团队就分成比例各执一词，双方先后晒出后台截图。这里把两版后台数据并列，标出可核对与不可核对的字段。",
    cover: "https://readdy.ai/api/search-image?query=empty%20livestream%20studio%20at%20night%20with%20ring%20light%20and%20dark%20screens%2C%20warm%20crimson%20rim%20light%2C%20moody%20editorial%20photography%2C%20cinematic%20grain%2C%20no%20text&width=1200&height=800&seq=chigua-cover-04&orientation=landscape",
    coverAlt: "夜间空置直播间补光灯与暗屏的暗调氛围图",
    updatedAt: "2026-09-10",
    evidenceCount: 35,
    status: "持续更新",
    heat: 88,
    tags: ["后台数据", "分成比例", "各执一词"],
    timeline: [
      { date: "2026-09-02", title: "主播发文控诉", text: "主播发布长文称实际到账比例远低于口头约定的分成方案。" },
      { date: "2026-09-03", title: "团队晒后台截图", text: "运营团队公布 6 月结算后台截图，页面显示比例与主播说法不同。" },
      { date: "2026-09-05", title: "主播回应截图疑点", text: "主播指出对方截图缺失平台侧结算栏，且金额单位存在疑问。" },
      { date: "2026-09-10", title: "字段逐项标注", text: "本站把两版后台截图的可见字段逐项列出，标出哪些可对外核对。" },
    ],
    evidences: [
      { type: "截图证据", title: "主播提供的结算截图", desc: "含 6 月与 7 月两期，金额被部分打码，保留页面结构。", source: "主播个人账号", verified: false },
      { type: "截图证据", title: "团队提供的后台截图", desc: "仅保留比例栏，未见平台侧结算时间与订单明细。", source: "运营团队声明", verified: false },
      { type: "文字记录", title: "两版后台字段差异表", desc: "逐项对比可见字段，标出缺失项与无法核对的项。", source: "本站整理", verified: true },
      { type: "文字记录", title: "直播回放中的口头约定", desc: "主播与团队在公开直播中提及分成的原话片段转录。", source: "直播回放", verified: true },
    ],
  },
  {
    id: "trainee-contract-shot",
    title: "练习生合约截图流出",
    category: "娱乐事件",
    categorySlug: "entertainment",
    summary:
      "一份标注为「练习生合约」的文档截图在社交平台传播，条款与工作室公开说明并不一致。这里保留了页面结构与删改痕迹说明。",
    cover: "https://readdy.ai/api/search-image?query=scattered%20paper%20documents%20on%20dark%20table%20under%20warm%20desk%20lamp%2C%20some%20pages%20blurred%2C%20moody%20editorial%20photography%2C%20cinematic%20shadows%2C%20no%20text%20legible&width=1200&height=800&seq=chigua-cover-05&orientation=landscape",
    coverAlt: "暖色台灯下散落的纸质文档暗调特写",
    updatedAt: "2026-09-04",
    evidenceCount: 22,
    status: "已归档",
    heat: 71,
    tags: ["合约条款", "删改痕迹", "公开说明"],
    timeline: [
      { date: "2026-08-18", title: "截图开始传播", text: "3 张条款截图在社交平台出现，涉及期限与违约金两条内容。" },
      { date: "2026-08-19", title: "工作室回应", text: "工作室称「截图不完整且经过拼接」，但未提供合约公示途径。" },
      { date: "2026-08-21", title: "截图元信息被关注", text: "网友指出截图中两处行距与字体粗细不一致，可能存在后期处理。" },
      { date: "2026-09-04", title: "存档并标注疑点", text: "把逐处行距、字号差异整理成说明，作为待核实条目归档。" },
    ],
    evidences: [
      { type: "截图证据", title: "流传的 3 张条款截图", desc: "包含期限、违约金与附属条款三条，保留页面比例与滚动条位置。", source: "社交平台转发", verified: false },
      { type: "文字记录", title: "行距与字号差异说明", desc: "逐处标注两处行距异常与一处字体粗细不一致的位置。", source: "本站整理", verified: true },
      { type: "截图证据", title: "工作室回应原文截图", desc: "发布于 08-19，含账号认证信息与发布时间。", source: "工作室官方账号", verified: true },
    ],
  },
  {
    id: "drama-crew-schedule-shift",
    title: "剧组通告单改档争议",
    category: "影视剧组",
    categorySlug: "film",
    summary:
      "几张通告单显示拍摄计划在开机后一周内多次调整，与片方发布会口径存在出入。这里按日期排列，标出可与官方信息交叉验证的部分。",
    cover: "https://readdy.ai/api/search-image?query=abandoned%20film%20set%20at%20dusk%20with%20warm%20amber%20sky%20and%20dark%20silhouettes%20of%20equipment%2C%20moody%20cinematic%20photography%2C%20soft%20grain%2C%20no%20text&width=1200&height=800&seq=chigua-cover-06&orientation=landscape",
    coverAlt: "黄昏时分影视布景与设备剪影的暗调氛围图",
    updatedAt: "2026-09-01",
    evidenceCount: 17,
    status: "整理中",
    heat: 52,
    tags: ["通告单", "改档", "发布口径"],
    timeline: [
      { date: "2026-08-12", title: "通告单截图流出", text: "4 张不同日期的拍摄通告单被匿名上传，显示外景拍摄时间多次顺延。" },
      { date: "2026-08-14", title: "片方回应", text: "片方称「因天气原因正常调整」，与通告单中标注的调整原因不完全对应。" },
      { date: "2026-08-25", title: "演职人员行程交叉验证", text: "部分演员公开行程与通告单日期一致，可作为旁证归档。" },
      { date: "2026-09-01", title: "整理暂停", text: "后续通告单来源中断，事件转入低频更新状态。" },
    ],
    evidences: [
      { type: "截图证据", title: "4 张拍摄通告单", desc: "含日期、场次与备注栏，部分姓名被打码，保留表格结构。", source: "匿名投稿", verified: false },
      { type: "截图证据", title: "片方回应原文", desc: "发布于 08-14 的官方说明截图，含发布时间。", source: "片方官方账号", verified: true },
      { type: "文字记录", title: "演员公开行程交叉表", desc: "把可核对的公开行程与通告单日期并列，标注一致与不一致处。", source: "本站整理", verified: true },
    ],
  },
];